import React from 'react';
import Icon from '../../../components/AppIcon';
import Input from '../../../components/ui/Input';

const SMSInput = ({ value, onChange }) => {
  const handleChange = (field, fieldValue) => {
    onChange({
      ...value,
      [field]: fieldValue
    });
  };

  return (
    <div className="space-y-4">
      <div className="flex items-center gap-2">
        <Icon name="MessageSquare" size={18} color="var(--color-accent)" strokeWidth={2} />
        <label className="text-sm font-caption font-medium text-foreground">
          SMS Message Details
        </label>
      </div>
      <Input
        label="Phone Number"
        type="tel"
        value={value?.phone || ''}
        onChange={(e) => handleChange('phone', e?.target?.value)}
        placeholder="+1 (555) 123-4567"
        required
        description="Include country code for international numbers"
      />
      <div className="space-y-2">
        <label className="text-sm font-caption font-medium text-foreground">
          Message Text
        </label>
        <textarea
          value={value?.message || ''}
          onChange={(e) => handleChange('message', e?.target?.value)}
          placeholder="Type your SMS message here..."
          rows={4}
          className="w-full px-4 py-3 rounded-lg border border-input bg-background text-foreground dark:text-white text-sm font-body resize-none focus:outline-none focus:ring-2 focus:ring-ring transition-smooth"
        />
        <div className="flex items-center justify-between text-xs font-caption text-muted-foreground">
          <span>{(value?.message || '')?.length} characters</span>
          <span>Standard SMS: 160 characters</span>
        </div>
      </div>
      <div className="flex items-start gap-2 p-3 rounded-lg bg-muted/30 border border-border">
        <Icon name="Info" size={16} color="var(--color-muted-foreground)" strokeWidth={2} className="mt-0.5 flex-shrink-0" />
        <p className="text-xs font-caption text-muted-foreground leading-relaxed">
          Scanning this QR code will open the user's messaging app with the phone number and message pre-filled.
        </p>
      </div>
    </div>
  );
};

export default SMSInput;